import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from '../../store/store';

import {
  Attributes,
  sessionUpdated,
  userAuthenticated,
} from "../../App/app";

import { Auth } from "aws-amplify";

interface CognitoUser {
  attributes: Attributes,
}


export const authenticateUser = createAsyncThunk( 'authenticateUser',
  async ( _, thunkAPI ) => {

    const state = thunkAPI.getState() as RootState;
    const { currentRequestId, loading } = state.app;

    if ( loading !== 'pending' || thunkAPI.requestId !== currentRequestId) return;

    // Don't proceed if user is about to logout
    if( location.pathname.includes( 'sign-out' ) || location.pathname.includes( 'logout' ) || location.pathname.includes( 'log-out' ) ) {
      return;
    }

    return Auth.currentAuthenticatedUser( { bypassCache: true, }).then( ( cognitoUser: CognitoUser ) => {
      return Auth.currentSession().then( ( session ) => {

        thunkAPI.dispatch( userAuthenticated(cognitoUser.attributes));

        thunkAPI.dispatch( sessionUpdated({
          accessToken: session.getAccessToken().getJwtToken(),
          idToken: session.getIdToken().getJwtToken(),
          refreshToken: session.getRefreshToken().getToken(),
        }))
        return cognitoUser.attributes;
      })

    }).catch( error => {
      // thunkAPI.dispatch( push( '/sign-out' ) );
      return false;
    })
  }
)
